import styled from 'styled-components';

export const LabelWrapper = styled.div`
  display: inline-block;
  width: 5.1cm;
  height: 3.4cm;
  text-align: center;
  margin: 0.05cm;
  position: relative;

  :nth-child(even) {
    margin-right: 0.45cm;
  }

  &.nextPage {
    page-break-after: always;
  }

  svg {
    width: 100%;
  }

  .variant {
    height: 48px;
    position: relative;
    .qr-container {
      position: absolute;
      right: 5px;
      top: 2px;
      z-index: 5;
      width: 43px;
      height: 43px
    }
    .product {
      position: absolute;
      right: 53px;
      top: 43px;
      z-index: 1;
      transform: translateY(-50%);
      line-height: 10px !important;
      text-align: right;
      font-weight: bold;
      font-size: 12px
    }
    .partner-info {
      position: absolute;
      right: 5px;
      top: 5px;
      font-size: 7px;
      z-index: 5;
      font-weight: bold;
    }
    .variant-id {
      position: absolute;
      left: 3px;
      top: 5px;
      z-index: 5;
      font-weight: bold;
      font: bold 12px monospace;
    }
    .product-code {
      position: absolute;
      left: 3px;
      top: 17px;
      font-size: 7px;
      z-index: 5;
      font-weight: bold;
      font: bold 9px monospace;
    }
    text {
      display: none;
    }
  }

  .inventory {
    margin-top: 16px;
    height: 48px;
  }

  .product span {
    font-size: 8px;
    font-weight: bold;
    position: relative;

    :nth-child(even) {
        margin-right: 0.45cm;
    }

    &.nextPage {
        page-break-after: always;
    }

    svg {
        width: 100%;
    }

    .variant {
        height: 48px;
        position: relative;

        .partner-info {
            position: absolute;
            right: 5px;
            top: 5px;
            font-size: 7px;
            z-index: 5;
            font-weight: bold;
        }
        .variant-id {
            position: absolute;
            left: 3px;
            top: 5px;
            font-size: 7px;
            z-index: 5;
            font-weight: bold;
            font: bold 7px monospace;
        }
        text {
            display: none;
        }
    }

    .inventory {
        margin-top: 16px;
        height: 48px;
    }

    .product {
        position: absolute;
        right: 0;
        left: 0;
        top: 47%;
        z-index: 1;
        transform: translateY(-50%);
        line-height: 7px !important;
    }
    .product span {
        font-size: 8px;
        font-weight: bold;
        position: relative;
        z-index: 2;
    }
`;
